import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useLanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  // Language codes are lowercase (ISO-639-1). The URL param is commonly
  // uppercase (e.g. ?lang=EN); normalize so i18next resource loading and the
  // project-translations request both hit the canonical code.
  const requestedLanguage = new URLSearchParams(location.search).get('lang')?.toLowerCase() || undefined;

  useEffect(() => {
    if (requestedLanguage && i18n.language !== requestedLanguage) {
      i18n.changeLanguage(requestedLanguage);
    }
  }, [requestedLanguage, i18n]);

  return {
    currentLanguage: i18n.language,
    // undefined when the URL has no `lang` param — pass this straight through
    // to LocalizationProvider's `language` prop so the request omits `lang`
    // entirely and the platform resolves the project's configured default
    // language, instead of always sending i18n's bundled-UI language ('en').
    requestedLanguage,
  };
};
